import axios from 'axios';

export function recordHostPayout(token, payload) {
    return axios.post(`${process.env.REACT_APP_API_URL}/admin/recordHostPayout`, payload, {
        headers: { Authorization: token },
    });
}
